export default class MessageBag {
  readonly messages: object;

  constructor(messages: object) {
    this.messages = {};

    for (const key in messages) {
      if (Object.hasOwn(messages, key)) {
        this.messages[key] = messages[key];
      }
    }
  }

  has(key: string): boolean {
    return Object.hasOwn(this.messages, key);
  }

  hasAny(keys: Array<any> = []): boolean {
    return keys.every(this.has);
  }

  get(key: string): Array<any> {
    if (!Object.hasOwn(this.messages, key)) {
      return [];
    }

    return this.messages[key];
  }

  all(): Array<string> {
    const all = [];

    Object.values(this.messages).forEach((messages) => {
      if (messages.constructor === Array) {
        messages.forEach((message) => {
          all.push(message);
        });
      } else {
        all.push(messages);
      }
    });

    return all;
  }
}
